// extracted by mini-css-extract-plugin
export default {"policy-details-error":"styles_policy-details-error__RmYfA"};